<bz-table uniqueId="oms-orders"
          appBringozIdGenerator="oms-orders-table"
          [items]="tableItems"
          [isLoading]="isLoading || !isInitialized"
          [rowHeight]="75"
          [defaultWidths]="defaultWidths"
          (fetchNext)="fetchNextEvent.emit()">

  <ng-template bzTableHeader>
    <div class="th col-id">
      <bz-checkbox size="sm"
                   class="select-checkbox"
                   appBringozIdGenerator="oms-orders-select-all-checkbox"
                   [disabled]="!orders?.length"
                   [checked]="isAllSelected"
                   [indeterminate]="isSelectAllIndeterminate"
                   [ariaLabel]="'Select All' | translate"
                   (checkedChange)="onToggleSelectAll()">
      </bz-checkbox>
      <span class="text-ellipsis">{{ 'Order' | translate }}</span>
      <bz-button variant="tertiary" size="fit" appBringozIdGenerator="oms-orders-table-sort-external-id-button"
                 [ariaLabel]="'Order' | translate" (clicked)="onSortTypeChange.emit('sortExternalIdType')">
        <bz-icon [icon]="sortIcons.sortExternalIdType"></bz-icon>
      </bz-button>
    </div>
    @if (columns?.account?.enabled) {
      <div class="th col-account">
        <span class="text-ellipsis">{{ 'OMS_TABLE_COLUMNS.account' | translate }}</span>
        <bz-button variant="tertiary" size="fit" appBringozIdGenerator="oms-orders-table-sort-account-button"
                   [ariaLabel]="'OMS_TABLE_COLUMNS.account' | translate" (clicked)="onSortTypeChange.emit('sortAccountReferenceNameType')">
          <bz-icon [icon]="sortIcons.sortAccountReferenceNameType"></bz-icon>
        </bz-button>
      </div>
    }
    @if (columns?.accountExternalId?.enabled) {
      <div class="th col-account-external-id text-ellipsis">{{ 'OMS_TABLE_COLUMNS.accountExternalId' | translate }}</div>
    }
    @if (columns?.branches?.enabled) {
      <div class="th col-branches text-ellipsis">{{ 'OMS_TABLE_COLUMNS.branches' | translate }}</div>
    }
    @if (columns?.contact?.enabled) {
      <div class="th col-contact text-ellipsis">{{ 'OMS_TABLE_COLUMNS.contact' | translate }}</div>
    }
    @if (columns?.phone?.enabled) {
      <div class="th col-phone text-ellipsis">{{ 'OMS_TABLE_COLUMNS.phone' | translate }}</div>
    }
    @if (columns?.location?.enabled) {
      <div class="th col-location text-ellipsis">{{ 'OMS_TABLE_COLUMNS.location' | translate }}</div>
    }
    @if (columns?.relations?.enabled) {
      <div class="th col-relations text-ellipsis">{{ 'OMS_TABLE_COLUMNS.relations' | translate }}</div>
    }
    @if (columns?.programType?.enabled) {
      <div class="th col-program-type text-ellipsis">{{ 'OMS_TABLE_COLUMNS.programType' | translate }}</div>
    }
    @if (columns?.sla?.enabled) {
      <div class="th col-sla">
        <span class="text-ellipsis">{{ 'OMS_TABLE_COLUMNS.sla' | translate }}</span>
        <bz-button variant="tertiary" size="fit" appBringozIdGenerator="oms-orders-table-sort-sla-button"
                   [ariaLabel]="'OMS_TABLE_COLUMNS.sla' | translate" (clicked)="onSortTypeChange.emit('sortSlaType')">
          <bz-icon [icon]="sortIcons.sortSlaType"></bz-icon>
        </bz-button>
      </div>
    }
    @if (columns?.timeToDeliver?.enabled) {
      <div class="th col-time-to-deliver text-ellipsis">{{ 'OMS_TABLE_COLUMNS.timeToDeliver' | translate }}</div>
    }
    @if (columns?.fulfillmentStatus?.enabled) {
      <div class="th col-fulfillment-status text-ellipsis">{{ 'Fulfillment Status' | translate }}</div>
    }
    @if (columns?.referenceIds?.enabled) {
      <div class="th col-reference-ids text-ellipsis">{{ 'OMS_TABLE_COLUMNS.referenceIds' | translate }}</div>
    }
    @if (columns?.createdAt?.enabled) {
      <div class="th col-created-at">
        <span class="text-ellipsis">{{ 'OMS_TABLE_COLUMNS.createdAt' | translate }}</span>
        <bz-button variant="tertiary" size="fit" appBringozIdGenerator="oms-orders-table-sort-created-at-button"
                   [ariaLabel]="'OMS_TABLE_COLUMNS.createdAt' | translate" (clicked)="onSortTypeChange.emit('sortCreatedAtType')">
          <bz-icon [icon]="sortIcons.sortCreatedAtType"></bz-icon>
        </bz-button>
      </div>
    }
    @if (columns?.proNumber?.enabled) {
      <div class="th col-pro-number text-ellipsis">{{ 'OMS_TABLE_COLUMNS.proNumber' | translate }}</div>
    }
    @if (columns?.schedulingSms?.enabled) {
      <div class="th col-scheduling-sms">
        <span class="text-ellipsis">{{ 'OMS_TABLE_COLUMNS.schedulingSms' | translate }}</span>
        <bz-button variant="tertiary" size="fit" appBringozIdGenerator="oms-orders-table-sort-scheduling-sms-button"
                   [ariaLabel]="'OMS_TABLE_COLUMNS.schedulingSms' | translate" (clicked)="onSortTypeChange.emit('sortSchedulingSmsType')">
          <bz-icon [icon]="sortIcons.sortSchedulingSmsType"></bz-icon>
        </bz-button>
      </div>
    }
    @if (columns?.billingOrder?.enabled) {
      <div class="th col-billing-order text-ellipsis">{{ 'OMS_TABLE_COLUMNS.billingOrder' | translate }}</div>
    }
    @if (columns?.itemsIds?.enabled) {
      <div class="th col-items-ids text-ellipsis">{{ 'OMS_TABLE_COLUMNS.itemsIds' | translate }}</div>
    }
    @if (columns?.itemsTypes?.enabled) {
      <div class="th col-items-types text-ellipsis">{{ 'OMS_TABLE_COLUMNS.itemsTypes' | translate }}</div>
    }
    @if (columns?.itemsBarcodes?.enabled) {
      <div class="th col-items-barcodes text-ellipsis">{{ 'OMS_TABLE_COLUMNS.itemsBarcodes' | translate }}</div>
    }
    @if (columns?.pallets?.enabled) {
      <div class="th col-pallets text-ellipsis">{{ 'OMS_TABLE_COLUMNS.pallets' | translate }}</div>
    }
    @if (columns?.notes?.enabled) {
      <div class="th col-notes text-ellipsis">{{ 'OMS_TABLE_COLUMNS.notes' | translate }}</div>
    }
    @for (column of enabledDynamicColumns; track column.cls) {
      <div class="th text-ellipsis" [class]="column.cls">{{ column.title }}</div>
    }
    @for (column of enabledPackageDynamicColumns; track column.cls) {
      <div class="th text-ellipsis" [class]="column.cls">{{ column.title }}</div>
    }
  </ng-template>

  <ng-template bzTableRow let-order>
    @if (order.skeleton) {
      <div class="tr oms-orders-skeleton-row" aria-busy="true">
        @for (cell of skeletonCells; track cell) {
          <div class="td" [class]="cell">
            <div class="layout-column full-width skeleton-cell">
              <bz-skeleton width="80%"></bz-skeleton>
              <bz-skeleton width="55%"></bz-skeleton>
            </div>
          </div>
        }
      </div>
    } @else {
      <app-oms-orders-table-row [order]="order"
                                [canRecover]="canRecoverOrders"
                                [columns]="columns"
                                [enabledDynamicColumns]="enabledDynamicColumns"
                                [enabledPackageDynamicColumns]="enabledPackageDynamicColumns"
                                [isSelected]="excludeMode ? !selectedKeys[order.id] : !!selectedKeys[order.id]"
                                (onToggleSelect)="onToggleOrderSelect(order)"
                                (onFilterByType)="onFilterByType.emit({type: $event.type, value: $event.value})"
                                (onSendToDispatch)="onSendToDispatch.emit($event)"
                                (onAddNote)="onAddNote.emit($event)"
                                (onSetOrderOnHold)="onSetOrderOnHold.emit($event)"
                                (onResumeOrder)="onResumeOrder.emit($event)"
                                (onManuallyCompleteOrder)="onManuallyCompleteOrder.emit($event)"
                                (onEdit)="onEdit.emit($event)"
                                (onDuplicate)="onDuplicate.emit($event)"
                                (onPrintBillOfLading)="onPrintBillOfLading.emit($event)"
                                (onDownloadBillOfLading)="onDownloadBillOfLading.emit($event)"
                                (onSendSchedulingSMSClicked)="onSendSchedulingSms.emit($event)"
                                (onSendSchedulingWhatsappClicked)="onSendSchedulingWhatsapp.emit($event)"
                                (onViewSchedulingLink)="onViewSchedulingLink.emit()"
                                (onRecover)="onRecover.emit($event)"
                                (onCancelOrder)="onCancelOrder.emit($event)">
      </app-oms-orders-table-row>
    }
  </ng-template>

  <bz-empty-state bzTableEmptyState
                  [title]="'No Orders Found' | translate"
                  image="assets/images/empty_state/empty_state_location_box.svg">
  </bz-empty-state>
</bz-table>
